import {
  categorySchema,
  type IActivityCategory,
  isGroupable,
} from "@medoma/models/activities";
import { knownFeatureFlagsSchema, useFeatureFlag } from "./FeatureFlags";

// Categories move from standalone occurrences to groups one at a time, each
// behind its own flag until its migration is done; once a category is grouped,
// none of its occurrences stand alone. A grouped occurrence is planned and
// finished through its group.
export const useIsGroupedCategory = () => {
  const { data: clinicVisitsAreGrouped } = useFeatureFlag(
    knownFeatureFlagsSchema.enum.GroupClinicVisitActivities,
  );

  return (category: IActivityCategory): boolean | undefined => {
    if (!isGroupable(category)) {
      return false;
    }

    switch (category) {
      case categorySchema.enum.HomeVisit:
        return true;
      case categorySchema.enum.ClinicVisit:
        return clinicVisitsAreGrouped;
      default:
        throw category satisfies never;
    }
  };
};
